module.exports = __webpack_public_path__ + "img/patientsDesktop.7ddff162.svg";